import React from 'react';
import { type KeyboardShortcut, keyCodeToString, Modifier } from '@applied/utils/keyboard';

import './keyboard-shortcut.scss';

export interface KeyboardShortcutLabelProps {
  shortcut: KeyboardShortcut;
}
const KeyboardShortcutLabel = (props: KeyboardShortcutLabelProps): JSX.Element => {
  const { shortcut } = props;

  const shortcutStrings = [];
  if (shortcut.ctrlModifier) {
    shortcutStrings.push(Modifier.CTRL);
  }
  if (shortcut.shiftModifier) {
    shortcutStrings.push(Modifier.SHIFT);
  }
  if (shortcut.altModifier) {
    shortcutStrings.push(Modifier.ALT);
  }
  if (shortcut.clickModifier) {
    shortcutStrings.push(Modifier.CLICK);
  }

  shortcutStrings.push(keyCodeToString(shortcut.keyCode));

  return <div className="keyboard-shortcut">{`(${shortcutStrings.join(' + ')})`}</div>;
};

export default KeyboardShortcutLabel;
